import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Icon from "../../components/Icon";

/**
 * Alternador das duas metades das notas de entrada (BDM-1038): as lançadas por
 * quem opera e o que a SEFAZ mandou contra o CNPJ.
 *
 * Fica ao lado da busca, no cabeçalho da página, e não junto da tabela: é
 * navegação entre duas listas, e precisa ser a primeira coisa que se vê ao
 * abrir a tela.
 */
export const PurchaseInvoiceTabs = ({ pending = 0 }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const tabs = [
        { label: 'Lançadas', to: '/purchase-invoice/list', icon: 'receipt-text' },
        { label: 'Recebidas da SEFAZ', to: '/purchase-invoice/sefaz', icon: 'inbox', badge: pending },
    ];

    return (
        <div className={`purchase-invoice-toggle`}>
            {tabs.map(tab => (
                <button
                    key={tab.to}
                    className={location.pathname === tab.to ? 'active' : ''}
                    onClick={() => navigate(tab.to)}
                >
                    <Icon name={tab.icon} size={15} strokeWidth={1.8} />
                    {tab.label}
                    {tab.badge > 0 && <span className={`badge`}>{tab.badge}</span>}
                </button>
            ))}
        </div>
    );
};

export default PurchaseInvoiceTabs;
